import { formatCountdown } from '@tankef/core';

import { Button } from '../../primitives/Button';
import { Modal } from '../../primitives/Modal';

export interface SessionWarningLabels {
  title?: string;
  message?: string;
  question?: string;
  continue?: string;
  signOut?: string;
}

const defaultLabels: Required<SessionWarningLabels> = {
  title: 'Tu sesión está por expirar',
  message: 'Por seguridad, tu sesión se cerrará automáticamente en:',
  question: '¿Deseas continuar trabajando?',
  continue: 'Continuar sesión',
  signOut: 'Cerrar sesión',
};

export interface SessionWarningProps {
  isOpen: boolean;
  remainingTime: number;
  onExtend: () => void;
  onLogout: () => void;
  labels?: SessionWarningLabels;
}

export function SessionWarning({
  isOpen,
  remainingTime,
  onExtend,
  onLogout,
  labels: labelsProp,
}: SessionWarningProps) {
  const labels = { ...defaultLabels, ...labelsProp };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onExtend}
      title={labels.title}
      size="sm"
      closeOnOverlayClick={false}
      closeOnEscape={false}
      showCloseButton={false}
      footer={
        <>
          <Button variant="outline" onClick={onLogout}>
            {labels.signOut}
          </Button>
          <Button onClick={onExtend}>{labels.continue}</Button>
        </>
      }
    >
      <div className="text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-warning-100">
          <svg
            className="h-8 w-8 text-warning-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <p className="text-tkf-fg-muted">{labels.message}</p>
        <p className="mt-2 text-3xl font-bold text-tkf-fg">{formatCountdown(remainingTime)}</p>
        <p className="mt-2 text-sm text-tkf-fg-muted">{labels.question}</p>
      </div>
    </Modal>
  );
}
